var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "15", height: "12", viewBox: "0 0 15 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "arrow_back_black"
    ),
    React.createElement("path", { d: "M3.196 5.056l3.458-3.458c.376-.376.376-.978 0-1.316-.376-.376-.977-.376-1.316 0L.263 5.319A.968.968 0 0 0 0 5.996c0 .226.075.489.263.677l5.038 5.038c.376.376.977.376 1.316 0 .375-.376.375-.978 0-1.316L3.158 6.937h10.977c.489 0 .865-.414.865-.94 0-.527-.338-.94-.827-.94H3.195z", fill: "#000", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ../public/images/back-arrow.svg?react-svg